<template>
  <div class="QuestionPathology">
    <MonthYearComponent
      :id="id"
      :legend="t(`${i18nRoot}_pathology-date-label`)"
      v-model:month="question!.month"
      v-model:year="question!.year"
    />

    <BaseText
      :id="id"
      :label="t(`${i18nRoot}_pathology-label`)"
      :placeholder="t(`${i18nRoot}_pathology-placeholder`)"
      v-model="question!.pathology"
      rows="4"
      :max-characters="1024"
      :rules="[required]"
    />

    <BaseText
      :id="id"
      :label="t(`${i18nRoot}_pathology-center-label`)"
      :placeholder="t(`${i18nRoot}_pathology-center-placeholder`)"
      v-model="question!.center"
      rows="4"
      :max-characters="1024"
      :rules="[required]"
    />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useRules } from '@/modules/core/composables/useRulesComposable'
import BaseText from '@/modules/core/components/ui/BaseText.vue'
import MonthYearComponent from '@/modules/core/components/formFields/MonthYearComponent.vue'
import QuestionPathology from '@/modules/common/common/models/APP/questionnaire/QuestionPathology'

const { t } = useI18n()
const { required } = useRules()

const i18nRoot = 'copy_questionnaire-form'

interface PropsInterface {
  id: string
}
withDefaults(defineProps<PropsInterface>(), {})

const question = defineModel<QuestionPathology>()
</script>
